import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { injectIntl, FormattedMessage } from 'react-intl'
import { form } from 'helpers/decorators'
import { get } from 'lodash'
import { TRANSLATION_PROJECTS } from '../../../constants/enums'

@form({
  form: 'upload-translation-approval-modal-form',
  disableHook: true
})
@injectIntl
class UploadTranslationApprovalModal extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    modalId: PropTypes.string,
    modal: PropTypes.func,
    isLoading: PropTypes.bool,
    onApprove: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired
  }

  getProjectName = code => {
    if(!code){
      return
    }

    const project = Object.values(TRANSLATION_PROJECTS).find(p => p.id === code)
    return  project ? <FormattedMessage id={project.intlKey} defaultMessage={project.defaultMessage} /> : code
  }

  getModalDefaultMessage() {
    return 'Translations for language: {language} and project: {project} will be updated.'
  }

  render() {
    const {
      modalId,
      modal,
      handleSubmit,
      isLoading,
      onApprove,
      language,
      project
    } = this.props

    return (
      <Modal id={modalId} modal={modal} customActions>
        <Title h2 className="text--center" intlKey="translationsManagement.modal.title">
          Do you want to update translations?
        </Title>

        <Form className="form" onSubmit={handleSubmit((onApprove))}>

          <div className="row">
            <div className="col-xs-12" style={{ textAlign: 'center', marginBottom: '15px' }}>
              <FormattedMessage
                id="label.upload_translation_question"
                defaultMessage={this.getModalDefaultMessage()}
                values={{
                  language: language,
                  project: this.getProjectName(project)
                }}
              />
              <br /><br />
              <FormattedMessage
                id="label.upload_translation_warning"
                defaultMessage='Make sure to update strings on CTEST first and test them there.'
              />
              <br /><br />
              <p style={{ fontWeight: 'bold' }}>
                <FormattedMessage
                  id="label.merge_account_modal_question_detail"
                  defaultMessage='Are you sure to continue?'
                />
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-6">
              <Button
                intlKey="button.dismiss"
                onClick={() => this.props.modal(null)}
                secondary
                type="button"
                style={{ marginRight: 10 }}
                disabled={isLoading}
              >
                Dismiss
              </Button>
            </div>
            <div className="col-xs-6 text--right">
              <Button
                isLoading={isLoading ? true : undefined}
                intlKey="button.approve"
                type="submit"
                onClick={onApprove}
              >
                Approve
              </Button>
            </div>
          </div>

        </Form>
      </Modal>
    )
  }
}

export default UploadTranslationApprovalModal
